import { getCsrf as abidGetCsrf, setCsrf as abidSetCsrf } from '@applyboard/abid-provider';

/** @deprecated Please don't use this.  Use `request` from `ui-utils` instead */
export var setCsrf = abidSetCsrf;

/** @deprecated Please don't use this.  Use `request` from `ui-utils` instead */
export var getCsrf = abidGetCsrf;